<template>
  <Modal v-model="deleteGroupModal" width="500" :transfer="false" :mask-closable="false"
    :title="$t('key1003169')" @on-visible-change="deleteGroupChange">
    <Form :model="deleteGroupForm" ref="deleteGroupForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row>
        <h2 class="font-size-13 font-weight-bold mb15 ml30">{{ $t('key1003213') }}</h2>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003212')" prop="ymsMerchantGroupId">
            <Select v-model="deleteGroupForm.ymsMerchantGroupId" filterable transfer :placeholder="$t('key1003211')" style="width: 305px;">
              <Option v-for="item in setGroupList" :value="item.ymsMerchantGroupId">{{ item.groupName }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="deleteGroupModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="deleteGroupBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "deleteGroupModal",
  mixins: [Mixin],
  props: {
    groupList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      deleteGroupModal: false,
      deleteGroupForm: {
        ymsMerchantGroupId: null
      },
      ruleValidate: {
        ymsMerchantGroupId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003211'), trigger: 'change'}
        ]
      },
      ymsMerchantGroupId: null,
      setGroupList: []
    };
  },
  methods: {
    // 初始化数据
    initDeleteGroupData(ymsMerchantGroupId) {
      this.ymsMerchantGroupId = ymsMerchantGroupId;
      this.setGroupList = this.groupList.filter((item) => {
        return item.ymsMerchantGroupId !== ymsMerchantGroupId;
      });
      this.deleteGroupModal = true;
    },
    // 保存按钮
    deleteGroupBtn() {
      let v = this;
      let query = {
        deleteYmsMerchantGroupId: v.ymsMerchantGroupId,
        updateYmsMerchantGroupId: v.deleteGroupForm.ymsMerchantGroupId
      };
      v.$refs['deleteGroupForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsMerchantGroup_deleteByYmsMerchantGroup, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.deleteGroupModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    deleteGroupChange(value) {
      let v = this;
      if (!value) {
        v.setGroupList = [];
        v.ymsMerchantGroupId = null;
        v.$nextTick(() => {
          v.$refs['deleteGroupForm'].resetFields();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>